<div [class.theme-white]="isWhiteTheme()" class="search-container">
  @if (isWhiteTheme()) {
    <i class="theme-white  search-icon icon-SearchDensity-1"></i>
  }

  <input
    type="text"
    [placeholder]="placeholder() | translate"
    name="text"
    class="input"
    [attr.aria-label]="placeholder()| translate"
    [class.theme-white]="isWhiteTheme()"
    [(ngModel)]="value"
    (input)="inputHandler($event)"
    (keyup.enter)="emitBtnEvent()"
  >
  @if (isCross()) {
    <div class="close-search"><i class="icon-X " (click)="closeSearch()"></i></div>
  }

  @if (isWhiteTheme() && searchTextValue()) {
    <div class="close-search" [class.theme-white]="isWhiteTheme()"><i class="icon-X " (click)="closeSearch()"></i></div>
  }

  @if (!isWhiteTheme()) {
    <button (click)="emitBtnEvent()" aria-label="Search" type="submit">
      <i class="search-icon icon-SearchDensity-1"></i>
    </button>
  }
</div>
